import infoBlocks from './extensions/infoBlocks';
import { set, assign } from 'lodash';

const layout = {
  xs: 12
};

const pages = {
  ref: 'pages',
  title: 'Pages',
  group: 'Pages',
  id: 'pages',
  type: 'object',
  tabs: ['Main'],
  properties: {
    title: {
      tab: 'Main',
      layout: {
        ...layout,
        md: 6
      },
      type: 'string',
      label: 'Title',
      component: 'text'
    },
    slug: {
      tab: 'Main',
      layout: {
        ...layout,
        md: 6
      },
      type: 'string',
      transform: 'kebabcase',
      label: 'Slug',
      component: 'text'
    },
    status: {
      tab: 'Main',
      layout: {
        ...layout,
        md: 6
      },
      type: 'string',
      label: 'Status',
      component: 'select',
      enum: [
        {
          label: 'Draft',
          value: 'draft'
        },
        {
          label: 'Preview',
          value: 'preview'
        },
        {
          label: 'Published',
          value: 'published'
        },
        {
          label: 'Trash',
          value: 'trash'
        }
      ]
    },
    order: {
      tab: 'Main',
      layout: {
        ...layout,
        md: 6
      },
      type: 'number',
      label: 'Order',
      component: 'text'
    },
    images: {
      tab: 'Main',
      layout: {
        ...layout
      },
      type: 'array',
      label: 'Images',
      component: 'file'
    },
    content: {
      tab: 'Main',
      layout: {
        ...layout
      },
      type: 'array',
      label: 'Content',
      component: 'wysiwyg'
    }
  },
  extensions: {
    onProp: 'slug',
    extend: (prop, obj) => {
      switch (prop) {
        case '': {
          obj.tabs.push('Services');

          assign(
            obj.properties,
            infoBlocks({
              label: 'Services',
              key: 'services',
              tab: 'Services'
            })
          );

          obj.tabs.push('Products');
          assign(
            obj.properties,
            infoBlocks({
              label: 'Products',
              key: 'products',
              tab: 'Products'
            })
          );
          break;
        }
      }
      return obj;
    }
  }
};

export default pages;

export const mockData = {
  title: 'Woot',
  slug: 'woot'
};
